import React from "react";
import ServiceIconBase, { ServiceIconProps } from "./ServiceIconBase";

/** Upright phone with a home dot — "Reparación de celulares". */
export const PhoneRepairIcon: React.FC<ServiceIconProps> = ({ size }) => (
  <ServiceIconBase size={size}>
    <rect x="6" y="2" width="12" height="20" rx="2.5" />
    <circle cx="12" cy="18" r="0.75" fill="currentColor" stroke="none" />
  </ServiceIconBase>
);

export default PhoneRepairIcon;
